import Loader from '@/globalComponents/loader';
import React from 'react';

interface FullPageLoaderProps {
  isLoading: boolean;
}

export const FullPageLoader = (props: FullPageLoaderProps) => {
  const { isLoading } = props;

  if (!isLoading) {
    return <></>;
  }

  return (
    <div
      className="fixed grid place-content-center w-full h-full inset-0 bg-[rgba(0,0,0,0.5)] z-10"
      data-testid="loader"
    >
      <Loader />
    </div>
  );
};
